"use strict";

angular.module("customer")
.controller("OrderConsolidationController", function(
    $rootScope, $scope, $state, $stateParams, $timeout, $compile, $q, $http, Language, UserService, OrderConsolidationService,
    FlashBag, gettextCatalog, StateExtensionService, ModalService, UserCustomerService, ORDER_STATUS, appConfig
) {
    var _this = this;
    $scope.orderItemTypeChoices = {
        SALES: 'sales',
        RETURNS: 'returns',
        INVENTORY_RETURNS: 'inventory_returns'
    }
    $scope.orderStatusChoices = {
        TRANSMITTED: ORDER_STATUS.TRANSMITTED,
        INVOICED: ORDER_STATUS.INVOICED,
        MODIFIED: ORDER_STATUS.MODIFIED
    }

    var orderItemType = $scope.orderItemTypeChoices.SALES;
    if ($stateParams['order-item-type']) {
        orderItemType = $stateParams['order-item-type'];
    }

    var orderItemSummaryChoices = {
        sales: 'order_items_summary',
        returns: 'return_order_items_summary',
        inventory_returns: 'inventory_return_order_items_summary'
    }
    $scope.orderItemSummary = orderItemSummaryChoices[orderItemType];

    $scope.orderStatus = {
        transmitted: false,
        modified: false,
        invoiced: false
    }

    $scope.selectAll = true;

    var deliveryDateStart = moment().startOf('day');
    var deliveryDateEnd = moment().startOf('day');
    if (orderItemType === $scope.orderItemTypeChoices.SALES) {
        $scope.orderStatus.transmitted = true;
        $scope.orderStatus.modified = true;
        deliveryDateStart.add(1, "days");
        deliveryDateEnd.add(1, "days");
        $scope.selectAll = false;
    }
    else {
        $scope.orderStatus.invoiced = true;
    }

    if ($stateParams['delivery-date-start']) {
        deliveryDateStart = moment($stateParams['delivery-date-start']);
    }
    if ($stateParams['delivery-date-end']) {
        deliveryDateEnd = moment($stateParams['delivery-date-end']);
    }

    function getStatusFilter() {
        var statusFilter = [];
        angular.forEach($scope.orderStatusChoices, function(status) {
            if ($scope.orderStatus[status]) {
                statusFilter = statusFilter.concat(status);
            }
        })
        return statusFilter.join(',');
    }

    $scope.params = {
        "search": $stateParams.search,
        "deliveryDateStart": deliveryDateStart,
        "deliveryDateEnd": deliveryDateEnd,
        "orderSourcePartnership": undefined,
        "productSupplierPartnership": undefined,
        "creationDateStart": undefined,
        "creationDateEnd": undefined,
        "orderItemType": orderItemType,
        "status": getStatusFilter()
    }
    $scope.orders = [];
    $scope.sourcePartnerships = [];
    $scope.manufacturerPartnerships = [];
    $scope.totalCount = 0;
    $scope.selectedCount = 0;
    $scope.errors = {};
    var promises = [];
    var loaded = false;

    $scope.sourcePartnerships = OrderConsolidationService.getPartnerships();
    promises.push($scope.sourcePartnerships.$promise);
    $scope.sourcePartnerships.$promise.then(function onSuccess(data) {
        var deferred = $q.defer();
        if (data.length) {
            var sourcePartnershipId = null;
            var manufacturerPartnershipId = null;
            $scope.sourcePartnerships = data;

            if ($stateParams.source) {
                sourcePartnershipId = $stateParams.source;
            } else if ($scope.sourcePartnerships.length === 1) {
                $scope.sourcePartnership = $scope.sourcePartnerships[0];
                sourcePartnershipId = $scope.sourcePartnership.partnership_id;
                $scope.manufacturerPartnerships = $scope.sourcePartnership.product_suppliers;
            }
            if ($scope.manufacturerPartnerships.length === 1) {
                $scope.manufacturerPartnership = $scope.manufacturerPartnerships[0];
                manufacturerPartnershipId = $scope.manufacturerPartnership.partnership_id;
            }

            _this.updateSourcePartnership(sourcePartnershipId).then(function onSuccess() {
                _this.updateManufacturerPartnership(manufacturerPartnershipId);

                loaded = true;
                _this.query();
                deferred.resolve();
            });
        } else {
            $timeout(function() {
                $state.go("404");
            });
            deferred.reject();
        }
        return deferred.promise;
    });

    this.query = function() {
        if (!loaded || !$scope.params.orderSourcePartnership) {
            return;
        }
        $scope.errors = {};
        OrderConsolidationService.query(
            {
                "search": $scope.params.search,
                "order_source_partnership": $scope.params.orderSourcePartnership,
                "product_supplier_partnership": $scope.params.productSupplierPartnership,
                "delivery_date_start": $scope.params.deliveryDateStart ? formatDate(moment($scope.params.deliveryDateStart).startOf('day')) : undefined,
                "delivery_date_end": $scope.params.deliveryDateEnd ? formatDate(moment($scope.params.deliveryDateEnd).endOf('day')) : undefined,
                "creation_date_start": $scope.params.creationDateStart ? moment($scope.params.creationDateStart).toISOString() : undefined,
                "creation_date_end": $scope.params.creationDateEnd ? moment($scope.params.creationDateEnd).toISOString() : undefined,
                "order_item_type": $scope.params.orderItemType,
                "status": $scope.params.status
            }
        ).$promise.then(
            function onSuccess(orders) {
                orders.forEach(
                    function(order) {
                        order.selected = $scope.selectAll;
                    });
                $scope.orders = orders;
                _this.refreshSelectionCounts();
            },
            function onError(response) {
                $scope.orders = [];
                $scope.errors = response.data;
                _this.refreshSelectionCounts();
            }
        );
    };

    this.chooseSourcePartnership = function(sourcePartnershipId) {
        this.updateSourcePartnership(sourcePartnershipId).then(function onSuccess() {
            _this.query();
        });
    };

    this.updateSourcePartnership = function(sourcePartnershipId) {
        var deferred = $q.defer();
        if (sourcePartnershipId) {
            sourcePartnershipId = parseInt(sourcePartnershipId);
        }
        $scope.params.orderSourcePartnership = sourcePartnershipId;
        StateExtensionService.updateUrlParams({source: $scope.params.orderSourcePartnership});
        var userCustomerId = null;
        angular.forEach($scope.sourcePartnerships, function(value) {
            if (value.partnership_id === sourcePartnershipId) {
                userCustomerId = value.user_customer_id;
                $scope.manufacturerPartnerships = value.product_suppliers;
                if ($scope.manufacturerPartnerships.length === 1) {
                    $scope.manufacturerPartnership = $scope.manufacturerPartnerships[0];
                    $scope.params.productSupplierPartnership = $scope.manufacturerPartnership.partnership_id;
                }
            }
        });

        if (userCustomerId) {
            return UserCustomerService.choose(userCustomerId).$promise.then(UserService.refreshCurrentUser);
        } else {
            deferred.resolve();
        }
        return deferred.promise;
    };

    this.chooseManufacturerPartnership = function(manufacturerPartnershipId) {
        this.updateManufacturerPartnership(manufacturerPartnershipId);
        this.query();
    };

    this.updateManufacturerPartnership = function(manufacturerPartnershipId) {
        if (manufacturerPartnershipId) {
            manufacturerPartnershipId = parseInt(manufacturerPartnershipId);
            $scope.params.productSupplierPartnership = manufacturerPartnershipId;
        }
    };

    this.updateStatusFilter = function() {
        $scope.params['status'] = getStatusFilter();
        this.query();
    };

    this.updateOrderItemTypeFilter = function() {
        $scope.orderItemSummary = orderItemSummaryChoices[$scope.params.orderItemType];
        this.query();
    };

    this.refreshSelectionCounts = function() {
        $scope.selectedCount = $scope.orders.filter(function(order) {
            return order.selected
        }).length;
        $scope.totalCount = $scope.orders.length;
        if ($scope.selectedCount > 0) {
            $scope.selectAll = true;
        }
        else if ($scope.selectedCount === 0 && $scope.totalCount > 0) {
            $scope.selectAll = false;
        }
    };

    this.toggleSelected = function(order) {
        order.selected = !order.selected;
        _this.refreshSelectionCounts();
    };

    this.consolidateOrders = function() {
        var selectedOrders = $scope.orders.filter(function(order) {
            return order.selected;
        });
        var selectedOrdersIds = selectedOrders.map(function(order) {
            return order.id;
        });
        OrderConsolidationService.consolidateOrders(
            $scope.params.orderSourcePartnership,
            $scope.params.productSupplierPartnership,
            selectedOrdersIds,
            $scope.params.orderItemType
        ).$promise.then(function onSuccess(results) {
            if (results.missing_order_items.length > 0) {
                var missingOrderItems = results.missing_order_items.map(function(orderItemData) {
                    return "" +
                        "<li>" +
                        formatProductData(orderItemData) +
                        " (" + gettextCatalog.getString("Buyer number: {{buyerNumber}}", {buyerNumber: orderItemData.buyer_number}) + ")" + " " +
                        gettextCatalog.getString("Quantity expected: {{quantity}}", {quantity: orderItemData.quantity}) +
                        "</li>";
                });

                FlashBag.preformattedWarning("<ul>" + missingOrderItems.join("\n") + "</ul>", gettextCatalog.getString("These ordered products are not available by supplier vendor"), true, true);
            }

            if (results.out_of_stock_catalog_entries.length > 0) {
                var outOfStockCatalogEntries = results.out_of_stock_catalog_entries.map(function(outOfStockCatalogEntryData) {
                    return "" +
                        "<li>" +
                        formatProductData(outOfStockCatalogEntryData.catalog_entry.product) +
                        gettextCatalog.getString("Quantity expected: {{quantity}}", {quantity: outOfStockCatalogEntryData.expected_quantity}) + " " +
                        gettextCatalog.getString("Quantity added to cart: {{quantity}}", {quantity: outOfStockCatalogEntryData.ordered_quantity}) +
                        "</li>";
                });

                FlashBag.preformattedWarning("<ul>" + outOfStockCatalogEntries.join("\n") + "</ul>", gettextCatalog.getString("These products are out of stock by the supplier vendor"), true, true);
            }

            if ($scope.params.orderItemType !== $scope.orderItemTypeChoices.SALES) {
                $http({
                    method: "POST",
                    url: appConfig.API_SERVER + "/catalog/customer/orders/returns/consolidate/"
                }).then(function onSuccess(response) {
                    var data = response.data;
                    $state.go("orderConfirmation", {
                        order: data,
                        display_error_message: data.warnings_detail.length
                    });
                }, function onError(response) {
                    FlashBag.apiError(response);
                });
            } else {
                FlashBag.success("The orders are consolidated and ready to submit", true);
                $state.go("shoppingCart");
            }
        }, function onError(response) {
            FlashBag.apiError(response);
        });
    };

    this.submit = function() {
        var contextMessage = gettextCatalog.getString("Your cart items will be replaced with the products of these orders.")
        if ($scope.params.orderItemType !== $scope.orderItemTypeChoices.SALES) {
             contextMessage = gettextCatalog.getString("Order consolidation confirmation for returns.");
        }
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Order Consolidation Confirmation"),
                    context: contextMessage,
                    message: gettextCatalog.getString("Do you want do continue?", null, "Order Consolidation")
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function(result) {
                if (result) {
                    _this.consolidateOrders();
                }
            });
        });
    };


    $q.all(promises).then(function onSuccess() {
        $scope.$watch("params.creationDateStart", function() {
            _this.query();
        });
        $scope.$watch("params.creationDateEnd", function() {
            _this.query();
        });
        $scope.$watch("params.deliveryDateStart", function() {
            if ($scope.params.deliveryDateStart) {
                StateExtensionService.updateUrlParams(
                    {'delivery-date-start': moment($scope.params.deliveryDateStart).format("YYYY-MM-DD")}
                );
            }
            _this.query();
        });
        $scope.$watch("params.deliveryDateEnd", function() {
            if ($scope.params.deliveryDateEnd) {
                StateExtensionService.updateUrlParams(
                    {'delivery-date-end': moment($scope.params.deliveryDateEnd).format("YYYY-MM-DD")}
                );
            }
            _this.query();
        });

        $scope.$on("$stateChangeStart", function(event, toState, toParams) {
            if (toState.name === "orderConsolidation") {
                event.preventDefault();
                StateExtensionService.updateUrlParams({search: toParams.search});
                $scope.params.search = toParams.search;
                _this.query();
            }
        });
    });

    function formatDate(date) {
        return date.format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    }

    function formatProductData(productData) {
        var upc = productData.upc ? (" (" + gettextCatalog.getString("UPC: {{upc}}", {upc: productData.upc}) + ")") : "";
        var supplierCode = productData.supplier_code ? (" (" + gettextCatalog.getString("Supplier code: {{supplierCode}}", {supplierCode: productData.supplier_code}) + ")") : "";
        return productData.name[Language.getLanguage()] + upc + supplierCode;
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/order-consolidation/order-consolidation.controller.js
// module id = 948
// module chunks = 0